/*
 * Optional region. Visibility depends on the answer to a question.
 */

import React from 'react';
import {
  Mode,
  castDataType,
  DataType
} from '../common.jsx';

import Helpers from './helpers.jsx';
import Resolver from '../component_resolver.jsx';

import * as FormComponent from '../form_components.jsx';
import Opt from '../../../hooks/opt.js';

// const SELECTION_COMPONENTS =[
//     'radio_selection',
//     'radio_selection_free_text',
//     'dropdown_selection',
//     'multi_dropdown_selection',
//     'checkbox_selection',
//     'dropdown_selection_with_search',
//     'dropdown_selection_with_async_options',
//     'checkbox_selection_free_text'
// ]

const NUMBER_COMPONENTS = [
    'adalia_me_calculation', 
    'adalia_me_calculation_v2', 
    'number_field', 
]

const COMPARE_OPERATORS = [
    {label: '=', value: 'equals'},
    {label: '<', value: 'lessThan'},
    {label: '>', value: 'greaterThan'},
    {label: '<=', value: 'lessThanOrEqual'},
    {label: '>=', value: 'greaterThanOrEqual'},
    {label: '!=', value: 'notEqual'}
]

const COMPARISION_MAP = {
  equals: (a, b) => a === b,
  greaterThan: (a, b) => a > b,
  lessThan: (a, b) => a < b,
  greaterThanOrEqual: (a, b) => a >= b,
  lessThanOrEqual: (a, b) => a <= b,
  notEqual: (a, b) => a !== b
};
export default class OptionalRegion extends FormComponent.GridLayout {

        static get CATEGORY() {
            return 'layout';
        }

        static get TYPE() {
            return 'optional_region';
        }

        /* 
          Add the dependencies as related ids
        */ 
        static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = '') {
          return [...(super.resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope) || []), ...(content.dependencies.filter(d => d.componentId !== null).map(d => repeatedFieldScope + '[' + d.componentId+ ']') || [])]
        }

        static icon(){
            return <i className="fa fa-question"></i>;
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                dependencies: [
                    {componentId: null, optionValue: null, type: null}
                ],
                dependencyOperator: 'OR', // or AND
                rows: [
                    [{span: 1, component: null}]
                ]
            });
        }

        static deleteNestedComponent(componentContent, componentId) {
            let found = super.deleteNestedComponent(componentContent, componentId);

            // Delete empty rows if they are not the last row (placeholder for next drop)
            if (found) {
                componentContent.rows = componentContent.rows.filter((row, i) => {
                    return (row[0].component || i == componentContent.rows.length - 1)
                });
            }
            return found;
        }

        static dropComponent(dropArea, targetContent, droppedContent, components, isNested) {
            let dropped = super.dropComponent(dropArea, targetContent, droppedContent, components, isNested);
            
            // Add empty placeholder for next component to drop
            if (dropped && ((targetContent.rows[targetContent.rows.length - 1] || [])[0] || {}).component) {
                targetContent.rows.push([{span: 1, component: null}]);
            }
            return dropped;
        }

        constructor(props) {
            super(props);

            this.addDependency = this.addDependency.bind(this);
            this.deleteDependency = this.deleteDependency.bind(this);
            this.selectDependencyComponent = this.selectDependencyComponent.bind(this);
            this.onChangeDependencyValue = this.onChangeDependencyValue.bind(this);
            this.dataValidator = this.dataValidator.bind(this);
            this.updateDependencyOperator = this.updateDependencyOperator.bind(this);
        }

        deleteAnswers() {
            if (this.props.deleteOptionalRegionAnswerCallback) {
                this.props.deleteOptionalRegionAnswerCallback(this.props.content.id);
            }
        }

        componentDidUpdate(prevProps) {
            super.componentDidUpdate();
            if (!this.shouldRenderView(this.props) && this.shouldRenderView(prevProps)) {
                // Component disappeared from view
                // Delete answers and attachments
                this.deleteAnswers();
            }
        }

        renderView() {
            if (!this.shouldRenderView(this.props)) {
                return null;
            } else {
                return super.renderView();
            }
        }

        renderSettings() {
            let componentOptions = this.dependencyComponentOptions().map((o, i) => {
                return <option key={i} value={o[0]} data-type={o[2]}>{o[1]}</option>;
            });
            let rows = this.props.content.dependencies.map((d, di) => {
                let preventChangesOnSafeMode = !this.allowModifyInSafeMode && !(this.props.content.savedOptionsCount <= di);

                let conditionComponent = null;
                if (NUMBER_COMPONENTS.includes(d.type)){
                    conditionComponent = (
                        <>
                            <td>
                                <select className='form-control' onChange={(e) => this.onChangeDependencyValue(e, di, 'operator')} value={d.operator} autoComplete={this.getAutoComplete()}>
                                    {COMPARE_OPERATORS.map((o) => {
                                        return <option key={`${d.componentId}-option-${o.value}`} value={o.value}>{o.label}</option>
                                    })}
                                </select>
                            </td>
                            <td>
                                <input 
                                    type='number' 
                                    style={{minWidth: '5rem'}} 
                                    data-index={di} 
                                    className='form-control' 
                                    value={d.value} 
                                    onChange={(e) => this.onChangeDependencyValue(e, di, 'value')}
                                    autoComplete={this.getAutoComplete()}
                                    />
                            </td>
                        </>
                    )
                } else {
                    let optionOptions = this.dependencyOptionOptions(d.componentId).map((o, i) => {
                        return <option key={`${d.componentId}-option-${i}`} value={o[0]}>{o[1]}</option>;
                    });
                    conditionComponent = (
                        <td>
                            <select className="form-control" data-index={di} onChange={(e) => this.onChangeDependencyValue(e, di, 'optionValue')} value={d.optionValue} disabled={preventChangesOnSafeMode} autoComplete={this.getAutoComplete()}>
                                {optionOptions}
                            </select>
                        </td>
                    )
                }
                return (
                    <div key={di} className="dependency-row">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-control" data-index={di} onChange={this.selectDependencyComponent} value={d.componentId} disabled={preventChangesOnSafeMode} autoComplete={this.getAutoComplete()}>
                                            {componentOptions}
                                        </select>
                                    </td>
                                    {conditionComponent}
                                    <td>
                                        {!preventChangesOnSafeMode &&
                                            <a href="#" className="btn btn-danger" data-index={di} onClick={this.deleteDependency}>
                                                <i className="icon-trash"></i>
                                            </a>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            });
            return (
                <div ref="settings">
                    <div className="setting">
                        <p className="description">
                            {I18n.t('optional_region_explanation', {scope: 'fe'})}
                        </p>
                    </div>
                    <div className="setting">
                        <label>
                            {I18n.t('dependencies', {scope: 'fe'})}
                        </label>
                        <div className="optional-region-dependencies">
                            {rows}
                        </div>
                        <a href="#" className="btn btn-primary" onClick={this.addDependency}><i className="icon-add"></i> {I18n.t('add_dependency', {scope: 'fe'})}</a>
                    </div>
                    <div className="setting" key={this.props.content.dependencyOperator}>
                        <label>{I18n.t('dependency_requirement', {scope: 'fe'})}</label>
                        <div className="checkbox-list">
                            <label>
                                <input type="radio" name="dependencyOperator" defaultChecked={this.props.content.dependencyOperator == 'OR'} defaultValue="OR" onChange={this.updateDependencyOperator} disabled={!this.allowModifyInSafeMode} />
                                {I18n.t('require_any', {scope: 'fe'})}
                            </label>
                            <label>
                                <input type="radio" name="dependencyOperator" defaultChecked={this.props.content.dependencyOperator == 'AND'} defaultValue="AND" onChange={this.updateDependencyOperator} disabled={!this.allowModifyInSafeMode} />
                                {I18n.t('require_all', {scope: 'fe'})}
                            </label>
                        </div>
                    </div>
                </div>
            );
        }

        addDependency(event) {
            let content = JSON.parse(JSON.stringify(this.props.content));

            if (content.savedOptionsCount == undefined) {
                content.savedOptionsCount = content.dependencies.length;
            }
            
            content.dependencies.push({componentId: null, type: null});
            this.props.updateSettingsCallback(content.id, content, true);

            event.preventDefault();
        }

        deleteDependency(event) {
            let content = JSON.parse(JSON.stringify(this.props.content));
            let deletedIndex = parseInt(event.currentTarget.getAttribute('data-index'), 10);
            content.dependencies.splice(deletedIndex, 1);
            this.props.updateSettingsCallback(content.id, content, true);

            event.preventDefault();
        }

        dependencyComponentOptions() {
            let options = [['', I18n.t('dependent_question_placeholder', {scope: 'fe'})]];
            if (this.props.findComponentsCallback) {
                const validComponents = [...this.props.findComponentsCallback({ type: NUMBER_COMPONENTS }),
                                        ...this.props.findComponentsCallback({ className: 'Selection' })]
                options = options.concat(validComponents.map((c) => {
                    let label = Helpers.getText(c.translations, c.label, this.props.language);
                    return [
                        c.id,
                        (label != '') ? label : (c.reportKey || '' != '') ? c.reportKey : '[ ' + I18n.t('no_label_or_key', {scope: 'fe'}) + ' ]',
                        c.type
                    ];
                }));
            }
            return options;
        }

        dependencyOptionOptions(componentId) {
            let options = [['', I18n.t('dependent_option_placeholder', {scope: 'fe'})]];

            if (this.props.findComponentsCallback) {
                this.props.findComponentsCallback({ id: componentId }).forEach((c) => {
                    if (c.useOptionLibrary) {
                        const opts = Helpers.Option.getOptionSetComponentOptions(c, this.props.optionSetValues, this.props.optionSetHierarchyValues, this.props.language);
                        opts.forEach((o) => {
                            options.push([o.value, Helpers.Option.getOptionText(o, c, this.props.language)])
                        });
                    } else {
                        c.options.forEach((group) => {
                            group.options.forEach((o) => {
                                let label = Helpers.getText(c.translations, o.label, this.props.language);
                                options.push([
                                    o.value,
                                    (label != '') ? label : '[ ' + I18n.t('no_label', {scope: 'fe'}) + ' ] - ' + o.label
                                ]);
                            });
                        });
                    }
                });
            }
            return options;
        }

        selectDependencyComponent(event) {
            let content = JSON.parse(JSON.stringify(this.props.content));
            let select = jQuery(event.currentTarget);
            let dataType = jQuery(select).find('option:selected').data('type')
            let newComponent = {
                componentId: select.val(),
                optionValue: null,
                type: dataType
            };
            if (NUMBER_COMPONENTS.includes(dataType)){
                newComponent = {
                    componentId: select.val(),
                    operator: 'equals',
                    type: dataType,
                    value: 0
                }
            }
            content.dependencies[parseInt(select.attr('data-index'), 10)] = newComponent;
            this.props.updateSettingsCallback(content.id, content, true);

            event.preventDefault();
        }

        onChangeDependencyValue(event, index, optionType) {
            let content = JSON.parse(JSON.stringify(this.props.content));
            let select = jQuery(event.currentTarget);

            content.dependencies[index][optionType] = select.val();
            this.props.updateSettingsCallback(content.id, content, true);
            event.preventDefault();
        }

        updateDependencyOperator(event) {
            let content = JSON.parse(JSON.stringify(this.props.content));

            content.dependencyOperator = event.currentTarget.value;
            this.props.updateSettingsCallback(content.id, content, true);

            event.preventDefault();
        }

        shouldRenderView(props) {
            return !([Mode.FILL, Mode.VIEW].indexOf(props.mode) != -1 && !this.isVisible(props) && !props.content.visible);
        }

        isVisible(props) {
            if (this.inEditMode || props.content.dependencies.length == 0) {
                return true;
            }

            let visible = (props.content.dependencyOperator == 'AND') ? true : false;

            if (props.findComponentsCallback) {
                props.content.dependencies.forEach((d) => {
                    let linkedComponent = props.findComponentsCallback({id: d.componentId})[0];
                    if (linkedComponent) {
                        let cClass = Resolver.componentClassName(linkedComponent.type);
                        let cProps = {
                            content: linkedComponent,
                            answers: props.answers,
                            prefillAnswers: props.prefillAnswers
                        };
                        let linkedAnswer = null;

                        // Try finding answer inside a shared repeated field scope or top level
                        if (props.repeatedFieldScope) {
                            linkedAnswer = (new FormComponent[cClass](Object.assign({repeatedFieldScope: props.repeatedFieldScope}, cProps))).getRawAnswer(this.context);
                        }
                        if (!linkedAnswer) {
                            linkedAnswer = (new FormComponent[cClass](cProps)).getRawAnswer(this.context);
                        }

                        // The answer can already be an array in case of multiple selection
                        linkedAnswer = (Array.isArray(linkedAnswer) ? linkedAnswer : [linkedAnswer]).map((a) => (castDataType(a, linkedComponent.dataType)));
                        if (props.content.dependencyOperator == 'AND') {
                            visible = (visible && this.dataValidator(linkedAnswer, d, linkedComponent));
                        } else {
                            visible = (visible || this.dataValidator(linkedAnswer, d, linkedComponent));
                        }
                    }
                });
            }
            return visible;
        }

        dataValidator(linkedAnswer, d, linkedComponent){
            const { dataType, type } = linkedComponent
            if (NUMBER_COMPONENTS.includes(type) && !isNaN(d.value) && linkedAnswer.length > 0){
                // the calculation_v2 data_type is string
                const currentType = dataType === DataType.STRING ? DataType.DECIMAL : dataType
                const compare = COMPARISION_MAP[d.operator]
                return compare(castDataType(linkedAnswer[0], currentType), castDataType(d.value, currentType))
            } else {
                return linkedAnswer.indexOf(castDataType(d.optionValue, dataType)) != -1
            }
        }

        containerClassNames() {
            let classNames = super.containerClassNames();

            if (!this.isVisible(this.props)) {
                classNames.push('opacity-50');
            }
            return classNames;
        }
}